module.exports = __webpack_public_path__ + "img/zuoye.a4af0c40.png";